// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"6cd557e1","157":"bb8eae89","358":"2c283b2e","379":"5058baff","463":"2c4ef0cd","510":"80da9341","516":"11da1f1d","633":"b8dd7741","726":"5d3905e4","794":"91b71833","863":"d05b9159","896":"abc349a7","973":"0552246e"}[chunkId] + ".chunk.js";
};